import { makeStyles } from "@material-ui/styles";


export const useStyle = makeStyles(() => ({
  claimsheader: {
    background: "#FFFFFF",
    borderRadius: "8px",
  },
  claimstitle: {
    padding: "10px 0 10px 0",
    "& ul": {
      listStyle: "none",
      margin: "0",
      "& li": {
        display: "inline-block",
        fontFamily: "Lato",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.0015em",
        color: "#000000",
        marginLeft: "10px",
      }
    },
  },

  claimStatussuccess: {
    color: "#000",
    display:" inline-block",
    height: "32px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "32px",
    padding: "0 12px",
    borderRadius: "16px",
    backgroundColor: "rgba(95, 146, 72, 0.3)",
    marginBottom: "5px",
    marginRight: "5px",
  },
  claimStatusdanger:{
    color: "#000",
    display:" inline-block",
    height: "32px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "32px",
    padding: "0 12px",
    borderRadius: "16px",
    backgroundColor: " rgba(243, 125, 128, 0.3)",
    marginBottom: "5px",
    marginRight: "5px",
  },
  claimactionbtn:{
    textAlign: "center",
    paddingTop: "10px",
    "& li":{
      listStyle: "none"
    },
    "& h6": {
      fontFamily: 'Lato',
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "20px",
      letterSpacing: "0.001em",
      color: "#000000",
      margin: "0 !important"
    },
  },
  waitingPeridod:{
    color: "#fff",
    display:" inline-block",
    height: "32px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "32px",
    padding: "0 12px",
    borderRadius: "16px",
    backgroundColor: "#183e4b",
    marginBottom: "5px",
    marginRight: "5px",
  },
  flaggedReason: {
    fontSize: "12px !important",
    fontFamily: "Open Sans !important",
    fontWeight: "400 !important",
    color: "#000000 !important",
    lineHeight: "1.5 !important",
  },
  headerButtons: {
    display: "flex",
    gap: "8px",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  makerChecksRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
  approvalStatusWrapper: {
    padding: "14px 30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    justifyItems: "center",
    
    "& h6": {
      fontFamily: 'Lato',
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12px",
      letterSpacing: "0.001em",
      color: "#000000",
      margin: "0 !important"
    },
     "& p": {
      fontFamily: 'Open Sans',
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.005em",
      color: "#A9A9A9"
    }
  },

}));